<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    leftLabel: {
      type: String,
      default: '',
    },
    rightLabel: {
      type: String,
      default: '',
    },
  },
  computed: {
    leftValue() {
      return this.value > 0 ? `${Number(this.value.toFixed(2))}%` : '0%';
    },
    rightValue() {
      return this.value >= 0
        ? `${Number((100 - this.value).toFixed(2))}%`
        : '0%';
    },
  },
};
</script>

<template>
  <div>
    <div class="guage-label-box">
      <div class="guage-label-legend guage-label-color-left"></div>
      <div class="guage-text-label">
        {{ leftLabel }}
      </div>
      <div class="guage-text-label">
        {{ leftValue }}
      </div>
    </div>

    <div class="guage-label-box">
      <div class="guage-label-legend guage-label-color-right"></div>
      <div class="guage-text-label">
        {{ rightLabel }}
      </div>
      <div class="guage-text-label">
        {{ rightValue }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.guage-label-box {
  @include flex-center-justify(flex-end);
  text-align: left;
  margin-bottom: 1rem;
}
.guage-label-legend {
  width: 1.663rem;
  height: 1.613rem;
  border: solid 0.063px $border-grey;
}
.guage-label-color-left {
  background-color: rgb(151, 193, 103);
}
.guage-label-color-right {
  background-color: rgb(64, 84, 190);
}
.guage-text-label {
  width: 4rem;
  margin-left: 0.5rem;
}
</style>
